import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import LoginModal from './LoginModal';
import './CSS/Global.css';
import './CSS/Local.css'
import logo from '../Components/img/100BILLION_TECH_name.png';
import { toast } from "react-toastify";
import img1 from "./img/100BILLION_ICON.png"

const NewHeader = ({ cartItems, fetchCartDataMainPage }) => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
    const serviceDropdownRef = useRef(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [shakeHeader, setShakeHeader] = useState(false);
    const [prevCartLength, setPrevCartLength] = useState(cartItems.length);
    const location = useLocation();
    const isActive = (path) => decodeURIComponent(location.pathname) === path;

    const login = JSON.parse(localStorage.getItem("login")) || false;
    useEffect(() => {
        if (cartItems.length > prevCartLength) {
            setShakeHeader(true);
            setTimeout(() => setShakeHeader(false), 500);
        }
        setPrevCartLength(cartItems.length);
    }, [cartItems.length]);

    useEffect(() => {
        const savedUserEmail = localStorage.getItem('userEmail');
        if (savedUserEmail) {
            setUserEmail(savedUserEmail);
            setIsLoggedIn(true);
        }
        if (login && login.emplyee_ID) {
            fetchCartDataMainPage();
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector(".new-header-wrapper-hbt");
            if (window.scrollY > 0) {
                header.classList.add("scrolled");
            } else {
                header.classList.remove("scrolled");
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // If dropdown is open and clicked outside its ref, close it
            if (
                serviceDropdownOpen &&
                serviceDropdownRef.current &&
                !serviceDropdownRef.current.contains(event.target)
            ) {
                setServiceDropdownOpen(false);
            }

            if (
                dropdownOpen &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [serviceDropdownOpen, dropdownOpen]);

    const handleLoginSuccess = (email) => {
        setUserEmail(email);
        setIsLoggedIn(true);
        setModalOpen(false);
        localStorage.setItem('userEmail', email);
    };

    const handleLogout = () => {
        localStorage.removeItem('login');
        localStorage.setItem("logoutToast", "Logout successfully");
        setIsLoggedIn(false);
        setUserEmail('');
        setLogoutModalOpen(false);

        // Navigate to home and refresh
        window.location.href = "/"; // This both reloads and navigates to home
    };

    useEffect(() => {
        const logoutToast = localStorage.getItem("logoutToast");
        if (logoutToast) {
            showToast(logoutToast, "success");
            localStorage.removeItem("logoutToast");
        }
    }, []);

    const showToast = (message, type = "info") => {
        toast(message, {
            type,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    };



    return (
        <>
            <div className="new-header-desktop">
                <header className="new-header-wrapper-hbt">
                    <div className="new-header-logo-hbt" onClick={() => navigate("/")}>
                        <img src={logo} alt="Logo" />
                    </div>

                    <nav className="new-header-nav-hbt">
                        <span
                            className={`new-header-link-hbt ${isActive("/") ? "active-link-hbt" : ""}`}
                            onClick={() => navigate("/")}
                        >
                            Home
                        </span>
                        <span
                            className={`new-header-link-hbt ${isActive("/start-growing-your-business-at-₹1999/Month") ? "active-link-hbt" : ""}`}
                            onClick={() => navigate("/start-growing-your-business-at-₹1999/Month")}
                        >
                            OMS
                        </span>
                        <span
                            className={`new-header-link-hbt ${isActive("/about-us") ? "active-link-hbt" : ""}`}
                            onClick={() => navigate("/about-us")}
                        >
                            About
                        </span>
                        <div className="new-header-dropdown-wrapper-hbt" ref={serviceDropdownRef}>
                            <span
                                className="new-header-link-hbt"
                                onClick={() => setServiceDropdownOpen((prev) => !prev)}
                            >
                                Services <i className={`fa fa-chevron-${serviceDropdownOpen ? "up" : "down"}`}></i>
                            </span>

                            <AnimatePresence>
                                {serviceDropdownOpen && (
                                    <motion.div
                                        className="new-header-service-dropdown-hbt"
                                        initial={{ opacity: 0, y: -10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -10 }}
                                        transition={{ duration: 0.2 }}
                                    >
                                        <div onClick={() => { navigate("/real-estate-website-development-service"); setServiceDropdownOpen(false); }}>
                                            Real Estate
                                        </div>
                                        <div onClick={() => { navigate("/website-development"); setServiceDropdownOpen(false); }}>
                                            Website Development
                                        </div>
                                        <div onClick={() => { navigate("/application-development"); setServiceDropdownOpen(false); }}>
                                            Application Development
                                        </div>
                                        <div onClick={() => { navigate("/get-your-online-store"); setServiceDropdownOpen(false); }}>
                                            Ecommerce Website
                                        </div>
                                        <div onClick={() => { navigate("/digital-marketing"); setServiceDropdownOpen(false); }}>
                                            Digital Marketing
                                        </div>
                                        <div onClick={() => { navigate("/meta-ads"); setServiceDropdownOpen(false); }}>
                                            Meta Ads
                                        </div>
                                        <div onClick={() => { navigate("/google-ads"); setServiceDropdownOpen(false); }}>
                                            Google Ads
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                        <span
                            className={`new-header-link-hbt ${isActive("/blog") ? "active-link-hbt" : ""}`}
                            onClick={() => navigate("/blog")}
                        >
                            Blog
                        </span>
                        <span
                            className={`new-header-link-hbt ${isActive("/contact-us") ? "active-link-hbt" : ""}`}
                            onClick={() => navigate("/contact-us")}
                        >
                            Contact
                        </span>
                    </nav>

                    <div className="new-header-actions-hbt">
                        {
                            login ? (
                                <div onClick={() => navigate('/cart')} // Directly using an inline function
                                    style={{ cursor: 'pointer' }} className={`cart-container cart-container-desktop ${shakeHeader ? "shake-header" : ""}`}>
                                    <div
                                        onClick={() => navigate('/cart')} // Directly using an inline function
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <i className="fas fa-shopping-cart"></i>
                                    </div>
                                    {cartItems.length > 0 && <span className="cart-badge" onClick={() => navigate('/cart')} >{cartItems.length}</span>}
                                </div>
                            ) : null
                        }

                        <button className="new-header-enquiry-hbt" onClick={() => navigate("/enquiry")}>
                            <i className="fa fa-envelope" style={{ marginRight: "6px" }}></i>
                            Enquiry
                        </button>

                        {login ? (
                            <div
                                ref={dropdownRef}
                                className="new-header-user-hbt"
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                            >
                                <img src={img1} alt="User" className="new-header-user-img-hbt" />
                                {login?.full_name?.length > 10
                                    ? login.full_name.slice(0, 10) + '…'
                                    : login?.full_name || ''}

                                <i className="fa fa-chevron-down new-header-chevron-hbt"></i>

                                <AnimatePresence>
                                    {dropdownOpen && (
                                        <motion.div
                                            className="new-header-dropdown-hbt"
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -10 }}
                                            transition={{ duration: 0.2 }}
                                        >
                                            {/* <div
                                                className="new-header-profile-hbt"
                                                onClick={() => {
                                                    navigate("/profile");
                                                    setDropdownOpen(false);
                                                }}
                                            >
                                                <i className="fa fa-user" style={{ marginRight: "5px" }}></i>
                                                My Profile
                                            </div> */}
                                            <div className="new-header-logout-hbt" onClick={handleLogout}>
                                                <i className="fa fa-sign-out" style={{ marginRight: "5px" }}></i>
                                                Logout
                                            </div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        ) : (
                            <button className="new-header-login-hbt" onClick={() => navigate("/login")}>
                                <i className="fa fa-sign-in-alt" style={{ marginRight: '6px' }}></i>
                                Login
                            </button>
                        )}
                    </div>
                </header>
            </div>



            {/* MOBILE HEADER */}
            <div className="new-header-mobile-hbt">
                <div className="new-header-mobile-header-container-hbt">
                    <div className="new-header-mobile-header-left-hbt" onClick={() => navigate("/")}>
                        <img src={logo} alt="Logo" className="new-header-mobile-logo-hbt" />
                    </div>
                    <div className="new-header-mobile-header-right-hbt">
                        {
                            login ? (
                                <div className={`cart-container cart-container-mobile ${shakeHeader ? "shake-header" : ""}`}>
                                    <div
                                        onClick={() => navigate('/cart')} // Directly using an inline function
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <i className="fas fa-shopping-cart"></i>
                                    </div>
                                    {cartItems.length > 0 && <span className="cart-badge" onClick={() => navigate('/cart')} >{cartItems.length}</span>}
                                </div>
                            ) : null
                        }
                        <button className="new-header-mobile-enquiry-btn-hbt" onClick={() => navigate("/enquiry")}>
                            <i className="fa fa-envelope" style={{ marginRight: 6 }}></i> Enquiry
                        </button>
                        <i className="fa fa-bars" onClick={() => setMobileMenuOpen(true)}></i>
                    </div>
                </div>

                <AnimatePresence>
                    {mobileMenuOpen && (
                        <>
                            <motion.div
                                className="new-header-mobile-drawer-overlay-hbt"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                onClick={() => setMobileMenuOpen(false)}
                            />
                            <motion.div
                                className="new-header-mobile-drawer-hbt"
                                initial={{ x: "-100%" }}
                                animate={{ x: 0 }}
                                exit={{ x: "-100%" }}
                                transition={{ duration: 0.3 }}
                            >
                                <div className="new-header-mobile-drawer-header-hbt">
                                    <img src={logo} alt="Logo" onClick={() => { setMobileMenuOpen(false); navigate("/"); }} />
                                    <i className="fa fa-times new-header-mobile-close-drawer-hbt" onClick={() => setMobileMenuOpen(false)}></i>
                                </div>

                                <div className="new-header-mobile-drawer-links-hbt">
                                    <div onClick={() => { navigate("/"); setMobileMenuOpen(false); }} className="new-header-mobile-border-bottom-hbt">Home</div>
                                    <div onClick={() => { navigate("/start-growing-your-business-at-₹1999/Month"); setMobileMenuOpen(false); }} className="new-header-mobile-border-bottom-hbt">OMS</div>
                                    <div onClick={() => { navigate("/about-us"); setMobileMenuOpen(false); }} className="new-header-mobile-border-bottom-hbt">About</div>
                                    <div
                                        className="new-header-mobile-drawer-link-with-dropdown-hbt"
                                        ref={serviceDropdownRef}
                                    >
                                        <div
                                            className="new-header-mobile-drawer-link-main-hbt new-header-mobile-border-bottom-hbt"
                                            onClick={() => {
                                                setServiceDropdownOpen((prev) => !prev);
                                            }}
                                        >
                                            Services <i className={`fa fa-chevron-${serviceDropdownOpen ? "up" : "down"}`}></i>
                                        </div>

                                        <AnimatePresence>
                                            {serviceDropdownOpen && (
                                                <motion.div
                                                    className="new-header-mobile-drawer-service-dropdown-hbt"
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: "auto", opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                >
                                                    <div
                                                        className="new-header-mobile-border-bottom-hbt new-header-mobile-margin-top-hbt"
                                                        onClick={() => {
                                                            navigate("/real-estate-website-development-service");
                                                            setMobileMenuOpen(false);
                                                        }}
                                                    >
                                                        Real Estate
                                                    </div>
                                                    <div
                                                        className="new-header-mobile-border-bottom-hbt new-header-mobile-margin-top-hbt"
                                                        onClick={() => {
                                                            navigate("/website-development");
                                                            setMobileMenuOpen(false);
                                                        }}
                                                    >
                                                        Website Development
                                                    </div>
                                                    <div
                                                        className="new-header-mobile-border-bottom-hbt new-header-mobile-margin-top-hbt"
                                                        onClick={() => {
                                                            navigate("/application-development");
                                                            setMobileMenuOpen(false);
                                                        }}
                                                    >
                                                        Application Development
                                                    </div>
                                                    <div
                                                        className="new-header-mobile-border-bottom-hbt new-header-mobile-margin-top-hbt"
                                                        onClick={() => {
                                                            navigate("/get-your-online-store");
                                                            setMobileMenuOpen(false);
                                                        }}
                                                    >
                                                        Ecommerce Website
                                                    </div>
                                                    <div
                                                        className="new-header-mobile-border-bottom-hbt new-header-mobile-margin-top-hbt"
                                                        onClick={() => {
                                                            navigate("/digital-marketing");
                                                            setMobileMenuOpen(false);
                                                        }}
                                                    >
                                                        Digital Marketing
                                                    </div>
                                                    <div
                                                        className="new-header-mobile-border-bottom-hbt new-header-mobile-margin-top-hbt"
                                                        onClick={() => {
                                                            navigate("/meta-ads");
                                                            setMobileMenuOpen(false);
                                                        }}
                                                    >
                                                        Meta Ads
                                                    </div>
                                                    <div
                                                        className="new-header-mobile-border-bottom-hbt new-header-mobile-margin-top-hbt"
                                                        onClick={() => {
                                                            navigate("/google-ads");
                                                            setMobileMenuOpen(false);
                                                        }}
                                                    >
                                                        Google Ads
                                                    </div>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                    <div className="new-header-mobile-border-bottom-hbt" onClick={() => { navigate("/blog"); setMobileMenuOpen(false); }}>Blog</div>
                                    <div className="new-header-mobile-border-bottom-hbt" onClick={() => { navigate("/contact"); setMobileMenuOpen(false); }}>Contact</div>
                                </div>

                                <div className="new-header-mobile-drawer-user-hbt">
                                    {login ? (
                                        <div className="new-header-mobile-drawer-logged-in-hbt">
                                            <div className="new-header-mobile-drawer-user-img-name-hbt"
                                                onClick={() => {
                                                    // navigate("/profile"); 
                                                    setMobileMenuOpen(false);
                                                }}>
                                                <img src={img1} alt="user" />
                                                <h3>
                                                    {login?.full_name?.length > 10
                                                        ? login.full_name.slice(0, 10) + '…'
                                                        : login?.full_name || ''}
                                                </h3>
                                            </div>
                                            <div className="new-header-mobile-drawer-profile-actions-hbt">
                                                <span onClick={handleLogout} style={{ marginLeft: "auto" }}>
                                                    <i className="fa fa-sign-out-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="new-header-mobile-drawer-login-hbt">
                                            {/* <div className="new-header-mobile-drawer-user-img-name-hbt" onClick={() => { navigate("/login"); setMobileMenuOpen(false); }}>
                                                <img src={img1} alt="user" />
                                                <h3>Hi, User</h3>
                                            </div> */}
                                            <button onClick={() => { navigate("/login"); setMobileMenuOpen(false); }}>
                                                <i className="fa fa-sign-in-alt" style={{ marginRight: 6 }}></i> Login
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </motion.div>
                        </>
                    )}
                </AnimatePresence>
            </div>
        </>
    );
};

export default NewHeader;
